var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"OItemComments"},[_c('o-item-comment-form',{attrs:{"show-comment-type-selector":_vm.showCommentTypeSelector}}),_c('m-item-comment-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }